/* eslint-disable no-useless-concat */
/* eslint-disable array-callback-return */
/* eslint-disable no-multi-assign */
/* eslint-disable no-alert */
/* eslint-disable function-paren-newline */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState, useRef } from "react";
import { ICategories, ITemplate } from "../ITemplateDetail";
import {
  Box,
  Typography,
  Divider,
  Rating,
  Checkbox,
  TextField,
  Autocomplete,
} from "@mui/material";
import { Button as MuiButton } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import { useStore } from "../../../store";
import { getLanguageCode } from "../LanguageCode";
import { getRegionCode, getAllCountryCode } from "../RegionCode";
import Axios from "../../../api/Axios";
import { getItem } from "../../../utils/nauth";
import { getBaseUrl } from "../../../constants";
import { postHistory } from "../../../api/History";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import useKeyPress from "../../../utils/custom/useKeyPress";
import { WindowSharp } from "@mui/icons-material";

type ModerationProps = {
  templates: ITemplate;
};

export const Moderation = ({ templates }: ModerationProps) => {
  const {
    TemplatesDetailStore: {
      moderation,
      loadData,
      emptyRegionCheck,
      setModeration,
      setLoading,
      setLoadData,
      setModerStatus,
      setMixabilityStatus,
      setRefernceStatus,
      setAssetStatus,
      setEntertainmentStatus,
      setRecommendedStatus,
      setGachaStatus,
      setGameStatus,
      setLanguageStatus,
      setRegionStatus,
      setExtraDescStatus,
      setEmptyRegionCheck,
    },
  } = useStore();

  const config = {
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Origin, Content-Type, Accept",
      "Content-type": "application/json",
    },
  };
  const baseUrl = `${getBaseUrl()}/v1/templates`;

  const [mixability, setMixability] = useState<number | 1>(
    templates.scores.mixability
  );
  const [reference, setReference] = useState<number | 1>(
    templates.scores.reference
  );
  const [asset, setAsset] = useState<number | 1>(templates.scores.asset);
  const [entertainment, setEntertainment] = useState<number | 1>(
    templates.scores.entertainment
  );

  const [autoLangCode, setAutoLangCode] = useState<any>({});
  const [regionCode, setRegionCode] = useState<string[]>(
    templates.metaCountryCode.length >= 249
      ? ["allcountrycode"]
      : templates.metaCountryCode
  );
  const [categoriesArr, setCategoriesArr] = useState<ICategories[]>(
    templates.categories
  );
  const [category, setCategory] = useState<string[]>(templates.category);
  const userEmail = getItem("email") || getItem("name") || "No name";
  const userRole = getItem("role");

  const [openLangModal, setOpenLangModal] = useState<boolean>(false);
  const [openRegionModal, setOpenRegionModal] = useState<boolean>(false);
  const [recommended, setRecommended] = useState<boolean>(false);
  const [gacha, setGacha] = useState<boolean>(false);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [multiRegionCode, setMultiRegionCode] = useState<any>([]);
  const [description, setDescription] = useState(
    templates.extraDescription.description === undefined
      ? ""
      : templates.extraDescription.description
  );
  const [moderationProgress, setModerationProgress] = useState(false);
  const valCheck = useRef<any>([]);

  const langModalHandler = () => {
    setOpenLangModal(!openLangModal);
  };
  const regionModalHandler = () => {
    setOpenRegionModal(!openRegionModal);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const isUserRole = () => {
    return userRole === "operator" || userRole === "admin";
  };
  const isAdminRole = () => {
    return userRole === "admin";
  };

  const getReviwer = async () => {
    const templateUrl = `${baseUrl}/${templates.templateId}`;
    let reviewer;
    try {
      await Axios("GET", templateUrl)
        .then((data) => {
          reviewer = data.reviewer;
          setCategoriesArr(data.categories);
        })
        .catch((err) => {
          console.log("getReviewr Err", err);
        });
    } catch (err) {
      console.log("getReviewer", err);
    }
    return reviewer;
  };

  const moderationHandler = async (type: boolean) => {
    if ((await getReviwer()) === "" && !isAdminRole()) {
      setLoadData(true);
      alert("Please register as a reviewer.");
      return;
    }

    if (templates.reviewer !== userEmail && !isAdminRole())
      return alert(
        "Reviewer is not registered or You are not the designated reviewer."
      );
    setMixability(templates.scores.mixability);
    setReference(templates.scores.reference);
    setAsset(templates.scores.asset);
    setEntertainment(templates.scores.entertainment);

    setCategory(templates.category);
    setCategoriesArr(templates.categories);

    // setLangCode(templates.metaLanguageCode);

    setRegionCode(
      templates.metaCountryCode.length >= 249
        ? ["allcountrycode"]
        : templates.metaCountryCode
    );

    setDescription(templates.extraDescription.description);

    setLangAndRegion();
    splitCategory(templates.category);

    setMixabilityStatus(false);
    setRefernceStatus(false);
    setAssetStatus(false);
    setEntertainmentStatus(false);
    setRecommendedStatus(false);
    setGachaStatus(false);
    setLanguageStatus(false);
    setRegionStatus(false);
    setExtraDescStatus(false);

    setLangAndRegion();

    if (type) setModeration(!moderation);
  };

  const splitCategory = (item: Array<string>) => {
    if (item.includes("⭐Recommended")) setRecommended(true);
    else setRecommended(false);
    if (item.includes("Gacha")) setGacha(true);
    else setGacha(false);
  };

  const toggleRecommended = () => {
    if (!recommended) {
      categoriesArr.includes({ id: "6458f16991b315a609781eb3" })
        ? setCategoriesArr([...categoriesArr])
        : setCategoriesArr([
            ...categoriesArr,
            { id: "6458f16991b315a609781eb3" },
          ]);
      category.includes("⭐Recommended")
        ? setCategory([...category])
        : setCategory([...category, "⭐Recommended"]);
      setRecommended(!recommended);
    } else {
      setCategoriesArr(
        categoriesArr.filter((e: any) => e.id !== "6458f16991b315a609781eb3")
      );
      setCategory(category.filter((e: any) => e !== "⭐Recommended"));
      setRecommended(!recommended);
    }
    const categoryLang = templates.categories;

    if (categoryLang.toString() !== categoriesArr.toString())
      setRecommendedStatus(false);
    else setRecommendedStatus(true);
  };

  const toggleGacha = () => {
    if (!gacha) {
      categoriesArr.includes({ id: "646fa1cadb9fff789a946348" })
        ? setCategoriesArr([...categoriesArr])
        : setCategoriesArr([
            ...categoriesArr,
            { id: "646fa1cadb9fff789a946348" },
          ]);

      category.includes("Gacha")
        ? setCategory([...category])
        : setCategory([...category, "Gacha"]);
      setGacha(!gacha);
    } else {
      setCategoriesArr(
        categoriesArr.filter((e: any) => e.id !== "646fa1cadb9fff789a946348")
      );
      setCategory(category.filter((e: any) => e !== "Gacha"));
      setGacha(!gacha);
    }
    const categoryLang = templates.categories;
    if (categoryLang.toString() !== categoriesArr.toString())
      setGachaStatus(false);
    else setGachaStatus(true);
  };

  const onChangeLang = (event: any, value: any) => {
    if (value) setAutoLangCode(value);
    if (templates.metaLanguageCode !== value.value) setLanguageStatus(true);
    else setLanguageStatus(false);
  };

  const onChangeRegion = (event: any, value: any) => {
    let extraDesc = description === undefined ? "" : description;
    if (value.length > 0) {
      if (value[value.length - 1].key === "AllCountryCode") {
        const all: any = [value[value.length - 1]];
        setMultiRegionCode(all);
        valCheck.current = all;

        description !== undefined &&
        description.includes("#_km_global_recommend_internal")
          ? ""
          : setDescription("#_km_global_recommend_internal " + extraDesc);
      } else if (value[0].key === "AllCountryCode") {
        value.shift();
        setMultiRegionCode(value);
        valCheck.current = value;

        description !== undefined &&
        description.includes("#_km_global_recommend_internal")
          ? setDescription(
              description
                .replaceAll("#_km_global_recommend_internal", "")
                .trim()
            )
          : "";
      } else if (value[0].key === "") {
        value.shift();
        setMultiRegionCode(value);
        valCheck.current = value;

        description !== undefined &&
        description.includes("#_km_global_recommend_internal")
          ? setDescription(
              description
                .replaceAll("#_km_global_recommend_internal", "")
                .trim()
            )
          : "";
      } else {
        setMultiRegionCode(value);
        valCheck.current = value;

        description !== undefined &&
        description.includes("#_km_global_recommend_internal")
          ? setDescription(
              description
                .replaceAll("#_km_global_recommend_internal", "")
                .trim()
            )
          : "";
      }
    } else {
      // 어떠한 값도 넣지 않을때
      description !== undefined &&
      description.includes("#_km_global_recommend_internal")
        ? setDescription(
            description.replaceAll("#_km_global_recommend_internal", "").trim()
          )
        : "";
      setMultiRegionCode([]);
      setEmptyRegionCheck(true);
    }

    const compareVal = value.map((item: any) => item.value);

    if (templates.metaCountryCode.toString() !== compareVal.toString())
      setRegionStatus(true);
    else setRegionStatus(false);

    emptyValue(valCheck);
  };

  const emptyValue = (item: any) => {
    const val = JSON.stringify(item);

    if (val.includes('"key":""')) {
      setEmptyRegionCheck(true);
    } else {
      setEmptyRegionCheck(false);
    }
  };

  const setLangAndRegion = () => {
    const translateLang = getLanguageCode.find(
      (obj: any) => obj.value === templates.metaLanguageCode
    );

    const findMatchItem = (value: any) => {
      const match = getRegionCode.find((obj: any) => obj.value === value);
      // console.log(match);
      return match ? match : null;
    };

    setAutoLangCode(translateLang);
    const keys: any = templates.metaCountryCode.map((value) =>
      findMatchItem(value)
    );

    if (keys.length === 249) {
      const arr: any = [{ key: "AllCountryCode", value: "allcountrycode" }];
      setMultiRegionCode(arr);
      valCheck.current = arr;
    } else {
      setMultiRegionCode(keys);
      valCheck.current = keys;
    }

    emptyValue(valCheck);
  };

  const handleDescription = (e: any) => {
    setDescription(e.target.value);

    const eDesc = templates.extraDescription.description || "";

    if (eDesc !== e.target.value) setExtraDescStatus(true);
    else setExtraDescStatus(false);
  };
  const handleKeyDown = async (event: KeyboardEvent) => {
    if (!isUserRole()) return;

    if (
      (event.target as HTMLElement)?.tagName !== "TEXTAREA" &&
      (event.target as HTMLElement)?.tagName !== "INPUT" &&
      (event.target as HTMLElement)?.tagName !== "LI"
    ) {
      switch (event.key) {
        case "v":
          if ((await getReviwer()) === "" && !isAdminRole()) {
            setLoadData(true);
            alert("Please register as a reviewer.");
            break;
          } else {
            handleSubmit();
          }
          break;

        default:
          console.log("Not Match: ", event.key);
      }
    }
  };

  const handleSubmit = async () => {
    if (multiRegionCode.length < 1) {
      alert("You must select at least one Region Code.");
      return;
    }

    if (
      multiRegionCode[0].value !== "allcountrycode" &&
      description !== undefined &&
      description.includes("#_km_global_recommend_internal")
    ) {
      alert(
        "#_km_global_recommend_internal value can only be entered when it is All Country Code. Please delete it and try again."
      );
      return;
    }

    if (
      multiRegionCode[0].value === "allcountrycode" &&
      description !== undefined &&
      !description.includes("#_km_global_recommend_internal")
    ) {
      alert(
        "When Region Code is All Country Code value, #_km_global_recommend_internal is required."
      );
      return;
    }

    if (emptyRegionCheck) {
      alert("Please select and save a region code, and try it again.");
      return;
    } else if (multiRegionCode.length < 1) {
      alert("Please select one or more area codes.");
      return;
    }

    setModerationProgress(true);
    // setLoading(true);

    let dataObj: any;

    if ((await getReviwer()) === "" && !isAdminRole()) {
      setLoadData(true);
      alert("Please register as a reviewer.");
      return;
    }

    const templatesIds = templates.templateId;
    const scores = {
      mixability: Number(mixability),
      reference: Number(reference),
      asset: Number(asset),
      entertainment: Number(entertainment),
    };
    if (!autoLangCode.value) {
      return console.log("autoLangCode.value");
    }
    const metaLanguageCode = autoLangCode.value;

    let metaCountryCode;

    if (multiRegionCode[0].key === "AllCountryCode") {
      metaCountryCode = getAllCountryCode;
    } else {
      metaCountryCode = multiRegionCode.map((item: any) => {
        return item.value;
      });
    }

    const categories = categoriesArr;

    if (
      categories.length < 1 ||
      metaLanguageCode.length < 1 ||
      metaCountryCode.length < 1
    ) {
      alert("Please check if there is an empty value.");

      return;
    }

    const extraDescription = {
      language: "en",
      languageName: "english",
      description:
        description || description !== undefined ? description.trim() : "",
    };

    const data = {
      scores,
      categories,
      metaLanguageCode,
      metaCountryCode,
      extraDescription,
    };

    try {
      await Axios("PATCH", `${baseUrl}/${templatesIds}`, data, config)
        .then(async (res) => {
          const tUserName = templates.author.name;
          const tUserId = templates.author.sub;

          if (!res) {
            const rcArr: any[] = multiRegionCode.map((item: any) => {
              return item.value;
            });
            dataObj = {
              action: "Moderation",
              templadteId: templates.templateId,
              userName: tUserName,
              userId: tUserId,
              scores: {
                mixability:
                  String(templates.scores.mixability || 3) +
                  " -> " +
                  String(mixability),
                reference:
                  String(templates.scores.reference || 3) +
                  " -> " +
                  String(reference),
                asset:
                  String(templates.scores.asset || 3) + " -> " + String(asset),
                entertainment:
                  String(templates.scores.entertainment || 3) +
                  " -> " +
                  String(entertainment),
              },
              description: templates.extraDescription.description
                ? templates.extraDescription.description + " -> " + description
                : "" + " -> " + description,
              category: {
                category:
                  templates.category.join(", ") + " -> " + category.join(", "),
              },
              metaLanguageCode:
                templates.metaLanguageCode + " -> " + autoLangCode.value,
              metaCountryCode:
                templates.metaCountryCode.length >= 249
                  ? "allcountrycode -> " + rcArr.join(", ")
                  : regionCode.length >= 249
                  ? templates.metaCountryCode + " -> allcountrycode"
                  : templates.metaCountryCode + " -> " + rcArr.join(", "),
            };

            setModerStatus(true);
            await postHistory(userEmail, dataObj).catch((err) => {
              console.log("HistoryErr", err);
            });
          } else {
            dataObj = {
              action: "Moderation",
              templadteId: templates.templateId,
              userName: tUserName,
              userId: tUserId,
              status: "Error",
              error: "Moderation (code: " + res.response.status + ")",
            };

            await postHistory(userEmail, dataObj).catch((err) => {
              console.log("HistoryErr", err);
            });

            alert(
              "An error occurred while changing the state. (Moderation Err)"
            );
            return false;
          }
        })
        .finally(() => {
          setMixabilityStatus(false);
          setRefernceStatus(false);
          setAssetStatus(false);
          setEntertainmentStatus(false);
          setRecommendedStatus(false);
          setGachaStatus(false);
          setGameStatus(false);
          setLanguageStatus(false);
          setRegionStatus(false);
          setExtraDescStatus(false);

          setLoadData(!loadData);
          setModeration(false);
          setCategoriesArr(categories);

          setModerationProgress(false);
          window.location.reload();
          // setLoading(false);
        });
    } catch (error) {
      console.log("moerationErr", error);
    }
  };

  useEffect(() => {
    splitCategory(templates.category);
    setLangAndRegion();
  }, []);

  useKeyPress(["v"], handleKeyDown);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          m: "10px",
          mt: "0px",
        }}
        minHeight={60}
      >
        <Box sx={{ width: "24px", mr: "8px" }} />
        <Box width={"11%"}>
          <Typography fontWeight={900}>Moderation</Typography>
        </Box>
        <Box width={"20%"}>
          <EditIcon
            sx={{ color: "#6750A4" }}
            style={{ cursor: "pointer" }}
            onClick={() => moderationHandler(true)}
          />
        </Box>
        <Box>
          <Typography color={"#07A499"}>
            {moderationProgress
              ? "In Progress..."
              : `First Reviewer : ${templates.firstReviewer}`}
          </Typography>
        </Box>
      </Box>
      {moderation && (
        <>
          <Divider sx={{ mt: "-25px" }} />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mt: "-15px",
              mb: "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />
            <Box width={"30%"}>
              <Typography fontWeight={500}>Mixability</Typography>
            </Box>
            <Box>
              <Rating
                value={mixability}
                onChange={(event, newValue) => {
                  if (templates.scores.mixability !== newValue)
                    setMixabilityStatus(true);
                  else setMixabilityStatus(false);
                  setMixability(newValue || 3);
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mt: "-25px",
              mb: "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />
            <Box width={"30%"}>
              <Typography fontWeight={500}>Reference</Typography>
            </Box>
            <Box>
              <Rating
                value={reference}
                onChange={(event, newValue) => {
                  if (templates.scores.reference !== newValue)
                    setRefernceStatus(true);
                  else setRefernceStatus(false);
                  setReference(newValue || 3);
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mt: "-25px",
              mb: "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />
            <Box width={"30%"}>
              <Typography fontWeight={500}>Asset</Typography>
            </Box>
            <Box>
              <Rating
                name="simple-controlled"
                value={asset}
                onChange={(event, newValue) => {
                  if (templates.scores.asset !== newValue) setAssetStatus(true);
                  else setAssetStatus(false);
                  setAsset(newValue || 3);
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mt: "-25px",
              mb: "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />

            <Box width={"30%"}>
              <Typography fontWeight={500}>Entertainment</Typography>
            </Box>
            <Box>
              <Rating
                name="simple-controlled"
                value={entertainment}
                onChange={(event, newValue) => {
                  if (templates.scores.entertainment !== newValue)
                    setEntertainmentStatus(true);
                  else setEntertainmentStatus(false);
                  setEntertainment(newValue || 3);
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mt: "-25px",
              mb: "-15px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />
            <Box width={"30%"}>
              <Typography fontWeight={500}>Category</Typography>
            </Box>

            {recommended ? (
              <>
                <Box>
                  <Typography
                    style={{ cursor: "pointer" }}
                    onClick={toggleRecommended}
                  >
                    ⭐Recommended&nbsp;
                  </Typography>
                </Box>
                <Box onClick={toggleRecommended} style={{ cursor: "pointer" }}>
                  <CheckIcon fontSize="small" sx={{ color: "#07A499" }} />{" "}
                  ,&nbsp;
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Typography
                    style={{ cursor: "pointer", opacity: 0.4 }}
                    onClick={toggleRecommended}
                  >
                    ⭐Recommended&nbsp;
                  </Typography>
                </Box>
                <Box onClick={toggleRecommended} style={{ cursor: "pointer" }}>
                  <CloseIcon fontSize="small" sx={{ color: "#B3261E" }} />{" "}
                  ,&nbsp;
                </Box>
              </>
            )}

            {gacha ? (
              <>
                <Box>
                  <Typography
                    style={{ cursor: "pointer" }}
                    onClick={toggleGacha}
                  >
                    Gacha&nbsp;
                  </Typography>
                </Box>
                <Box style={{ cursor: "pointer" }} onClick={toggleGacha}>
                  <CheckIcon fontSize="small" sx={{ color: "#07A499" }} />
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Typography
                    style={{ cursor: "pointer", opacity: 0.4 }}
                    onClick={toggleGacha}
                  >
                    Gacha&nbsp;
                  </Typography>
                </Box>
                <Box style={{ cursor: "pointer" }} onClick={toggleGacha}>
                  <CloseIcon fontSize="small" sx={{ color: "#B3261E" }} />
                </Box>
              </>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mt: "-10px",
              mb: "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />
            <Box width={"30%"}>
              <Typography fontWeight={500}>3rd Party Logo</Typography>
            </Box>
            <Box>
              <Typography>
                {templates.isThirdPartyLogo == null
                  ? "N/A"
                  : templates.isThirdPartyLogo
                  ? "Yes"
                  : "No"}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mt: "-10px",
              mb: "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />
            <Box width={"30%"}>
              <Typography fontWeight={500}>Language Code</Typography>
            </Box>

            <Box>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={getLanguageCode}
                value={autoLangCode}
                onChange={onChangeLang}
                getOptionLabel={(option: any) => {
                  return `${option.name} (${option.value})`;
                }}
                sx={{
                  width: 300,
                  "& .MuiInputBase-root": {
                    pt: "0px",
                    pb: "0px",
                  },
                }}
                renderInput={(params) => {
                  return <TextField {...params} />;
                }}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.name === value.name && option.value === value.value
                }
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mb: emptyRegionCheck ? "10px" : "-10px",
              mt: emptyRegionCheck ? "" : "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />
            <Box width={"30%"}>
              <Typography fontWeight={500}>Region Code</Typography>
            </Box>
            <Box flex={1}>
              <Autocomplete
                multiple
                onChange={onChangeRegion}
                options={getRegionCode}
                value={multiRegionCode}
                disableCloseOnSelect
                disableClearable
                getOptionLabel={(option) => `${option.key} (${option.value})`}
                isOptionEqualToValue={(option, value) =>
                  option.key === value.key && option.value === value.value
                }
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {`${option.key} (${option.value})`}
                  </li>
                )}
                style={{ width: "auto" }}
                sx={{
                  "& .MuiInputBase-root": {
                    pt: "0px",
                    pb: "0px",
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
              {emptyRegionCheck && (
                <Typography style={{ color: "red" }}>
                  Please select a region code.
                </Typography>
              )}
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mt: "-23px",
              mb: "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "24px", mr: "8px" }} />

            <Box width={"30%"}>
              <Typography fontWeight={500}>Extra Description</Typography>
            </Box>
            <Box sx={{ mt: "22px", overflowY: "scroll" }}>
              <TextField
                name={"note"}
                sx={{
                  width: "658px",
                  "& .MuiInputBase-root": {
                    height: 60,
                  },
                }}
                inputProps={{ style: { height: 45 } }}
                multiline
                maxRows={2}
                value={description}
                onChange={handleDescription}
              />
              <Typography style={{ color: "#07A499" }}>
                Please write a description in English.
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              m: "10px",
              mb: "-10px",
            }}
            minHeight={60}
          >
            <Box sx={{ width: "70%", mr: "8px" }} />
            <Box sx={{ width: "15%" }}>
              <MuiButton onClick={() => moderationHandler(false)}>
                Cancel
              </MuiButton>
            </Box>
            <Box>
              <MuiButton onClick={handleSubmit}>
                Sa
                <b>
                  <u>v</u>
                </b>
                e
              </MuiButton>
            </Box>
          </Box>
          <Divider />
        </>
      )}
    </>
  );
};
